import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  AfterViewInit,
  NgZone,
  HostListener,
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  finalize,
  of,
  Subject,
  Subscription,
  switchMap,
} from 'rxjs';
import { ApiservicesService } from 'src/app/services/apiservices.service';

interface IngressChart {
  _id: string;
  ingressType: string;
  importance: string;
  title: string;
  shortDescription: string;
  period: string;
  eventTimePeriod: string;
  color: string;
  name: string;
  email: string;
  createdAt: any;
  sector_focus: Array<string>;
  is_social_advo: boolean;
}

interface TitleOption {
  key: string;
  val: string;
}

interface CityApiTimezone {
  name: string;
  utcOffset: string;
  offset_string: string;
}

interface CityApiKey {
  timezone: CityApiTimezone;
  lat: number;
  lng: number;
  label: string;
  request_type: string;
}

interface CityOption {
  val: string; // display text in dropdown
  key: CityApiKey; // metadata
}

interface authorOption {
  val: string; // display text in dropdown
  key: string; // metadata
}

interface ChartFilters {
  startDate: string;
  endDate: string;
}
type SortValue = {
  field: 'eventTimestamp' | 'title' | 'createdAt';
  dir: 1 | -1;
};
type SearchItem = { val: string; key: string };

@Component({
  selector: 'app-ingress-charts-list',
  templateUrl: './ingress-charts-list.component.html',
  styleUrls: ['./ingress-charts-list.component.scss'],
})
export class IngressChartsListComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild('sentinel', { static: false })
  sentinel!: ElementRef<HTMLDivElement>;
  @ViewChild('dropdownSearchWrapper', { static: false })
  dropdownSearchWrapper: ElementRef;

  private observer?: IntersectionObserver;

  public allIngressData: IngressChart[] = [];
  private filteredCharts: IngressChart[] = [];
  public displayedCharts: IngressChart[] = [];
  searchTitleDisplay = '';

  public filters: ChartFilters = {
    startDate: '',
    endDate: '',
  };
  public sortOptions: { value: SortValue; label: string }[] = [
    {
      value: { field: 'eventTimestamp', dir: 1 },
      label: 'Nearest event dates first',
    },
    {
      value: { field: 'eventTimestamp', dir: -1 },
      label: 'Farthest event dates first',
    },
    {
      value: { field: 'createdAt', dir: 1 },
      label: 'Nearest Creating dates first',
    },
    {
      value: { field: 'createdAt', dir: -1 },
      label: 'Farthest Creating dates first',
    },

    { value: { field: 'title', dir: 1 }, label: 'Name (A–Z)' },
    { value: { field: 'title', dir: -1 }, label: 'Name (Z–A)' },
  ];

  public sortOption: SortValue = this.sortOptions[0].value;

  public uniqueLocations: string[] = [];
  public isLoading = false;
  public showNoResults = false;
  private page = 1;
  private readonly itemsPerPage = 12;
  private hasMore = true;
  public login_user_details: any = {};
  limit = 9;
  skip = 0;
  searchCondition = {};
  finalsearchCondition = {};
  onsearch = false;
  search_id: string | null = null;
  search_data: string = '';
  MIN_TITLE_CHARS = 2;

  titleSearch$ = new Subject<string>();
  private titleSub?: Subscription;

  titleResults: TitleOption[] = [];
  titleActiveIndex = -1;
  showTitleDropdown = false;
  titleLoading = false;
  searchTitleText = '';
  private searchSubject = new Subject<string>();
  selectedOption: SearchItem | null = null;
  suggestions: SearchItem[] = [];
  MIN_CITY_CHARS = 2;
  citySearch$ = new Subject<string>();
  citySub?: Subscription;

  citySearchText: string = '';
  cityLoading = false;
  showCityDropdown = false;
  cityActiveIndex = -1;
  cityResults: CityOption[] = [];
  cityDisplay = '';
  searchCity = '';
  searchError = false;
  searchTags = '';

  authorSearch$ = new Subject<string>();
  authorSub?: Subscription;
  authorSearchText: string = '';
  authorResults: authorOption[] = [];
  authorLoading = false;
  showauthorDropdown = false;
  authorActiveIndex = -1;
  authorDisplay = '';
  searchUserId = '';

  isSectorSearch = true;
  searchableSector = '';

  showSearchSectorDropdown = false;
  selectedSearchSectors: string[] = [];
  showAllSearchSelected = false;
  searchSectors: string[] = [];
  sectorOptions = [
    { key: 'Government & Leadership', val: 'governmentAndLeadership' },
    { key: 'Social Climate & Public Mood', val: 'socialClimateAndPublicMood' },
    { key: 'Weather & Agriculture', val: 'weatherAndAgriculture' },
    {
      key: 'Potential Conflicts & Alliances',
      val: 'potentialConflictsAndAlliances',
    },
    { key: 'Public Health & Workforce', val: 'publicHealthAndWorkforce' },
    {
      key: 'Communications & Transportation',
      val: 'communicationsAndTransportation',
    },
    { key: 'Justice, Law & Foreign Trade', val: 'justiceLawAndForeignTrade' },
    { key: 'Natural Disasters', val: 'naturalDisasters' },
  ];

  showPast = false;
  chartsCount = 0;

  popoverPosition = { top: 0, left: 0 };
  activeChartId: string | null = null;
  activeChart: any | null = null;

  constructor(
    private ngZone: NgZone,
    private cookieService: CookieService,
    private apiservice: ApiservicesService,
    private router: Router,
    public matSnackBar: MatSnackBar,
    private route: ActivatedRoute
  ) {
    this.login_user_details = this.cookieService.get('login_user_details')
      ? JSON.parse(this.cookieService.get('login_user_details'))
      : {};

    console.log('this.login_user_details---->', this.login_user_details);
  }
  public get apiSort(): { field: string; type: 'asc' | 'desc' } {
    return {
      field: this.sortOption.field,
      type: this.sortOption.dir === 1 ? 'asc' : 'desc',
    };
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (params['tags']) {
        this.searchTags = params['tags'];
        console.log('Tag from subscription:', this.searchTags);
      }

      if (params['sectors']) {
        this.searchableSector = params['sectors'];
        this.isSectorSearch = false;
        console.log('Sector from subscription:', this.searchableSector);
      }
    });
    this.titleSub = this.titleSearch$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((term) => {
          const q = (term || '').trim();
          if (!q || q.length < this.MIN_TITLE_CHARS) {
            this.titleResults = [];
            this.titleActiveIndex = -1;
            this.showTitleDropdown = !!q;
            return of(null);
          }

          this.titleLoading = true;
          const payload = { search_str: q };
          return this.apiservice
            .getHttpDataPost(
              'ingress-charts/title-autocomplete-search-name',
              payload
            )
            .pipe(catchError(() => of({ status: 'error', res: [] })));
        })
      )
      .subscribe((resp: any) => {
        this.titleLoading = false;
        if (!resp) return;

        const list: TitleOption[] = Array.isArray(resp?.res) ? resp.res : [];
        this.titleResults = list;
        this.showTitleDropdown = true;
        this.titleActiveIndex = this.titleResults.length ? 0 : -1;
      });

    this.authorSub = this.authorSearch$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((term) => {
          if (!term || term.trim().length < this.MIN_CITY_CHARS) {
            this.authorResults = [];
            this.authorActiveIndex = -1;
            this.showauthorDropdown = !!term;
            return of(null);
          }

          this.authorLoading = true;

          const payload = { search_str: term.trim() };
          return this.apiservice
            .getHttpDataPost(
              'ingress-charts/user-details-autocomplete',
              payload
            )
            .pipe(catchError(() => of({ status: 'error', res: [] })));
        })
      )
      .subscribe((resp: any) => {
        this.authorLoading = false;
        if (!resp) return;

        const list: authorOption[] = Array.isArray(resp?.res) ? resp.res : [];
        this.authorResults = list;
        this.showauthorDropdown = true;
        this.authorActiveIndex = this.authorResults.length ? 0 : -1;
      });

    this.citySub = this.citySearch$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((term) => {
          if (!term || term.trim().length < this.MIN_CITY_CHARS) {
            this.cityResults = [];
            this.cityActiveIndex = -1;
            this.showCityDropdown = !!term;
            return of(null);
          }

          this.cityLoading = true;

          const payload = { search_str: term.trim() };
          return this.apiservice
            .getHttpDataPost(
              'ingress-charts/autocomplete-search-by-location',
              payload
            )
            .pipe(catchError(() => of({ status: 'error', res: [] })));
        })
      )
      .subscribe((resp: any) => {
        this.cityLoading = false;
        if (!resp) return;

        const list: CityOption[] = Array.isArray(resp?.res) ? resp.res : [];
        this.cityResults = list;
        this.showCityDropdown = true;
        this.cityActiveIndex = this.cityResults.length ? 0 : -1;
      });

    this.fetchChartData(this.limit, this.skip, this.finalsearchCondition);
    this.fetchChartDataCount(this.limit, this.skip, this.finalsearchCondition);
    setTimeout(() => {
      this.uniqueLocations = ['New York', 'London', 'Tokyo', 'Sydney'];
    }, 500);
  }

  openPopover(chart: any, event: MouseEvent) {
    // Close others
    this.allIngressData.forEach((c: any) => (c.showPopover = false));

    chart.showPopover = true;
    this.activeChart = chart;

    const rect = (event.target as HTMLElement).getBoundingClientRect();
    this.popoverPosition = {
      top: rect.bottom + window.scrollY - 100,
      left: rect.left + window.scrollX - 100,
    };

    event.stopPropagation();
  }

  onToggleSocialAdvo(newValue: boolean, chart: any): void {
    console.log('Toggled:', newValue, chart);
    chart.is_social_advo = newValue;
    const payload = {
      _id: chart._id,
      is_social_advo: newValue,
    };
    this.apiservice
      .getHttpDataPost('ingress-charts/update-social-advo-flag', payload)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (response: any) => {
          if (response?.status === 'success') {
            this.matSnackBar.open(
              'Social Advo Status Updated Successfully',
              'Close',
              { duration: 3000 }
            );
          }
        },
        error: (err: any) => {
          console.error('Error fetching ingress charts:', err);
          this.matSnackBar.open(
            'Failed to Update Social Advo Status',
            'Close',
            { duration: 3000 }
          );
        },
      });
  }

  closePopover(chart?: any) {
    if (chart) {
      chart.showPopover = false;
    }
    this.activeChart = null;
  }
  onSortChange(val: SortValue) {
    this.sortOption = val;
  }

  getFormattedDate(dateString: string): string {
    const date = new Date(dateString);

    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'long' });
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12 || 12;

    return `${day}${this.getOrdinalSuffix(
      day
    )} ${month}, ${year} ${hours}.${minutes} ${ampm}`;
  }

  private getOrdinalSuffix(day: number): string {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  }

  fetchChartData(limit: number, skip: number, searchcondition: any) {
    this.isLoading = true;

    if (this.searchTags && this.searchTags.trim() !== '') {
      const tagCondition = { tags: { $in: [this.searchTags] } };

      if (!searchcondition || Object.keys(searchcondition).length === 0) {
        searchcondition = tagCondition;
      } else if (searchcondition.$and && Array.isArray(searchcondition.$and)) {
        const alreadyExists = searchcondition.$and.some(
          (cond: any) =>
            cond.tags &&
            cond.tags.$in &&
            cond.tags.$in.includes(this.searchTags)
        );
        if (!alreadyExists) {
          searchcondition.$and.push(tagCondition);
        }
      } else if (
        !(
          searchcondition.tags &&
          searchcondition.tags.$in &&
          searchcondition.tags.$in.includes(this.searchTags)
        )
      ) {
        searchcondition = { $and: [searchcondition, tagCondition] };
      }
    }
    if (this.searchableSector && this.searchableSector.trim() !== '') {
      const tagCondition = { sector_focus: { $in: [this.searchableSector] } };

      if (!searchcondition || Object.keys(searchcondition).length === 0) {
        searchcondition = tagCondition;
      } else if (searchcondition.$and && Array.isArray(searchcondition.$and)) {
        const alreadyExists = searchcondition.$and.some(
          (cond: any) =>
            cond.sector_focus &&
            cond.sector_focus.$in &&
            cond.sector_focus.$in.includes(this.searchableSector)
        );
        if (!alreadyExists) {
          searchcondition.$and.push(tagCondition);
        }
      } else if (
        !(
          searchcondition.sector_focus &&
          searchcondition.sector_focus.$in &&
          searchcondition.sector_focus.$in.includes(this.searchableSector)
        )
      ) {
        searchcondition = { $and: [searchcondition, tagCondition] };
      }
    }

    const payload = {
      condition: { limit, skip },
      searchcondition,
      sort: this.apiSort,
      project: {},
      token: '',
    };

    this.apiservice
      .getHttpDataPost('ingress-charts/ingress-chart-list-view-page', payload)
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;

          if (
            response?.status === 'success' &&
            Array.isArray(response.results.res.data)
          ) {
            const newCharts = response.results.res.data.map(
              (chartFromApi: any) => ({
                _id: chartFromApi._id,
                ingressType: chartFromApi.ingressType,
                importance: chartFromApi?.importance ?? 'High Impact',
                title: chartFromApi.title,
                shortDescription: chartFromApi.shortDescription,
                period: chartFromApi.effective_timePeriod,
                eventTimePeriod: chartFromApi.eventTimePeriod,
                name: chartFromApi?.author?.[0]?.name ?? 'System Generated',
                email: chartFromApi?.author?.[0]?.email ?? 'System Generated',
                createdAt: chartFromApi?.createdAt ?? '-',
                sector_focus: chartFromApi?.sector_focus ?? [],
                is_social_advo: chartFromApi?.is_social_advo ?? false,
              })
            );

            // append instead of replace
            this.allIngressData = [...this.allIngressData, ...newCharts];
            this.hasMore = response.results.res.hasMore;
          }
        },
        error: (err: any) =>
          console.error('Error fetching ingress charts:', err),
      });
  }
  fetchChartDataCount(limit: number, skip: number, searchcondition: any) {
    this.isLoading = true;

    if (this.searchTags && this.searchTags.trim() !== '') {
      const tagCondition = { tags: { $in: [this.searchTags] } };

      if (!searchcondition || Object.keys(searchcondition).length === 0) {
        searchcondition = tagCondition;
      } else if (searchcondition.$and && Array.isArray(searchcondition.$and)) {
        const alreadyExists = searchcondition.$and.some(
          (cond: any) =>
            cond.tags &&
            cond.tags.$in &&
            cond.tags.$in.includes(this.searchTags)
        );
        if (!alreadyExists) {
          searchcondition.$and.push(tagCondition);
        }
      } else if (
        !(
          searchcondition.tags &&
          searchcondition.tags.$in &&
          searchcondition.tags.$in.includes(this.searchTags)
        )
      ) {
        searchcondition = { $and: [searchcondition, tagCondition] };
      }
    }
    if (this.searchableSector && this.searchableSector.trim() !== '') {
      const tagCondition = { sector_focus: { $in: [this.searchableSector] } };

      if (!searchcondition || Object.keys(searchcondition).length === 0) {
        searchcondition = tagCondition;
      } else if (searchcondition.$and && Array.isArray(searchcondition.$and)) {
        const alreadyExists = searchcondition.$and.some(
          (cond: any) =>
            cond.sector_focus &&
            cond.sector_focus.$in &&
            cond.sector_focus.$in.includes(this.searchableSector)
        );
        if (!alreadyExists) {
          searchcondition.$and.push(tagCondition);
        }
      } else if (
        !(
          searchcondition.sector_focus &&
          searchcondition.sector_focus.$in &&
          searchcondition.sector_focus.$in.includes(this.searchableSector)
        )
      ) {
        searchcondition = { $and: [searchcondition, tagCondition] };
      }
    }

    const payload = {
      condition: { limit, skip },
      searchcondition,
      sort: this.apiSort,
      project: {},
      token: '',
    };

    this.apiservice
      .getHttpDataPost('ingress-charts/ingress-list-count-view-page', payload)
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;

          if (response?.status === 'success') {
            this.chartsCount = response.count;
          } else {
            console.warn('Fetch chart data count failed:', response);
            this.chartsCount = 0;
          }
        },
        error: (err: any) => {
          this.isLoading = false;
          console.error('Error fetching chart data count:', err);
          this.chartsCount = 0;
        },
      });
  }

  onScroll() {
    console.log('Past Data------------>>', this.showPast);
    console.log(
      'finalsearchCondition------------>>',
      this.finalsearchCondition
    );

    if (Object.keys(this.finalsearchCondition).length === 0) {
      if (this.showPast) {
        this.finalsearchCondition = { viewPast: true };
      }
    }
    if (this.skip === 0) {
      this.skip = 9;
      this.limit = 6;
    } else {
      this.skip += 6;
    }
    if (this.hasMore) {
      if (this.onsearch) {
        this.fetchChartData(this.limit, this.skip, this.finalsearchCondition);
      } else {
        if (this.showPast) {
          this.fetchChartData(this.limit, this.skip, this.finalsearchCondition);
        } else {
          this.fetchChartData(this.limit, this.skip, {});
        }
      }
    }
  }

  ngAfterViewInit(): void {
    this.setupObserver();
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
    this.citySub?.unsubscribe();
    this.authorSub?.unsubscribe();
    this.titleSub?.unsubscribe();
  }

  registerClick(_id: any) {
    this.router.navigateByUrl(`/ingress-chart-details/${_id}`);
  }

  setupObserver() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.isLoading) {
          this.onScroll();
        }
      });
    });

    if (this.sentinel?.nativeElement) {
      this.observer.observe(this.sentinel.nativeElement);
    }
  }

  // --- Handlers for title search ---
  onTitleInput(val: string) {
    this.searchTitleText = val;
    this.searchTitleDisplay = val;
    this.search_id = '';
    this.titleSearch$.next(val);
  }

  openTitleDropdown() {
    this.showTitleDropdown = true;
  }

  selectTitle(option: TitleOption) {
    this.search_id = option.key;
    this.searchTitleDisplay = option.val;

    this.showTitleDropdown = false;
    this.titleResults = [];
    this.searchTitleText = '';
    this.titleActiveIndex = -1;

    this.searchSubject.next(this.searchTitleDisplay);

    let searchCondition: any = { ...this.searchCondition };

    if (searchCondition['_id']) {
      delete searchCondition['_id'];
    }
    if (searchCondition.$and) {
      searchCondition.$and = searchCondition.$and.filter((c: any) => !c['_id']);
      if (searchCondition.$and.length === 0) {
        delete searchCondition.$and;
      }
    }

    const cityCondition = { _id: this.search_id };

    if (searchCondition.$and) {
      searchCondition.$and.push(cityCondition);
      this.searchCondition = searchCondition;
    } else if (Object.keys(searchCondition).length > 0) {
      this.searchCondition = { $and: [cityCondition, searchCondition] };
    } else {
      this.searchCondition = cityCondition;
    }

    console.log(
      'Final Search Condition:',
      JSON.stringify(this.searchCondition, null, 2)
    );
  }

  clearTitle(event: MouseEvent) {
    event.stopPropagation();
    this.searchTitleDisplay = '';
    this.searchTitleText = '';
    this.search_id = '';
    this.titleResults = [];
    this.titleActiveIndex = -1;
    this.showTitleDropdown = false;

    let searchCondition: any = { ...this.searchCondition };

    if (searchCondition['_id']) {
      delete searchCondition['_id'];
    }
    if (searchCondition.$and) {
      searchCondition.$and = searchCondition.$and.filter((c: any) => !c['_id']);

      if (searchCondition.$and.length === 0) {
        delete searchCondition.$and;
      } else if (searchCondition.$and.length === 1) {
        searchCondition = searchCondition.$and[0];
      }
    }

    this.searchCondition = searchCondition;

    console.log(
      'Final Search Condition after clear:',
      JSON.stringify(this.searchCondition, null, 2)
    );
  }

  onTitleKeydown(e: KeyboardEvent) {
    if (!this.showTitleDropdown || !this.titleResults.length) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      this.titleActiveIndex =
        (this.titleActiveIndex + 1) % this.titleResults.length;
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      this.titleActiveIndex =
        (this.titleActiveIndex - 1 + this.titleResults.length) %
        this.titleResults.length;
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (
        this.titleActiveIndex >= 0 &&
        this.titleActiveIndex < this.titleResults.length
      ) {
        this.selectTitle(this.titleResults[this.titleActiveIndex]);
      }
    } else if (e.key === 'Escape') {
      this.showTitleDropdown = false;
    }
  }

  onauthorInput(val: string) {
    this.authorSearchText = val;
    this.authorDisplay = val;
    this.authorSearch$.next(val);
  }

  openauthorDropdown() {
    this.showauthorDropdown = true;
  }

  selectauthor(option: authorOption) {
    this.searchUserId = option.val;
    this.authorDisplay = option.key;
    this.showauthorDropdown = false;
    this.authorSearchText = '';
    this.authorResults = [];
    this.authorActiveIndex = -1;

    let searchCondition: any = { ...this.searchCondition };

    if (searchCondition['userId']) {
      delete searchCondition['userId'];
    }
    if (searchCondition.$and) {
      searchCondition.$and = searchCondition.$and.filter(
        (c: any) => !c['userId']
      );
      if (searchCondition.$and.length === 0) {
        delete searchCondition.$and;
      }
    }

    const cityCondition = { userId: this.searchUserId };

    if (searchCondition.$and) {
      searchCondition.$and.push(cityCondition);
      this.searchCondition = searchCondition;
    } else if (Object.keys(searchCondition).length > 0) {
      this.searchCondition = { $and: [cityCondition, searchCondition] };
    } else {
      this.searchCondition = cityCondition;
    }

    console.log(
      'Final Search Condition:',
      JSON.stringify(this.searchCondition, null, 2)
    );
  }

  clearauthor(event: MouseEvent) {
    event.stopPropagation();
    this.authorDisplay = '';
    this.authorSearchText = '';
    this.searchUserId = '';
    this.authorResults = [];
    this.authorActiveIndex = -1;
    this.showauthorDropdown = false;

    let searchCondition: any = { ...this.searchCondition };

    if (searchCondition['userId']) {
      delete searchCondition['userId'];
    }
    if (searchCondition.$and) {
      searchCondition.$and = searchCondition.$and.filter(
        (c: any) => !c['userId']
      );

      if (searchCondition.$and.length === 0) {
        delete searchCondition.$and;
      } else if (searchCondition.$and.length === 1) {
        searchCondition = searchCondition.$and[0];
      }
    }

    this.searchCondition = searchCondition;

    console.log(
      'Final Search Condition after clear:',
      JSON.stringify(this.searchCondition, null, 2)
    );
  }

  onauthorKeydown(e: KeyboardEvent) {
    if (!this.showauthorDropdown || !this.authorResults.length) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      this.authorActiveIndex =
        (this.authorActiveIndex + 1) % this.authorResults.length;
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      this.authorActiveIndex =
        (this.authorActiveIndex - 1 + this.authorResults.length) %
        this.authorResults.length;
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (
        this.authorActiveIndex >= 0 &&
        this.authorActiveIndex < this.authorResults.length
      ) {
        this.selectauthor(this.authorResults[this.authorActiveIndex]);
      }
    } else if (e.key === 'Escape') {
      this.showauthorDropdown = false;
    }
  }
  trackByTitle(index: number, option: { val: string }) {
    return option.val;
  }
  trackByCity(index: number, option: { val: string }) {
    return option.val;
  }
  trackByAuthor(index: number, option: { val: string }) {
    return option.val;
  }

  onCityInput(val: string) {
    this.citySearchText = val;
    this.cityDisplay = val;
    this.citySearch$.next(val);
  }

  openCityDropdown() {
    this.showCityDropdown = true;
  }

  selectCity(option: CityOption) {
    this.searchCity = option.key.label;
    this.cityDisplay = option.val;
    this.showCityDropdown = false;
    this.cityResults = [];
    this.cityActiveIndex = -1;
    this.citySearchText = '';

    let searchCondition: any = { ...this.searchCondition };

    if (searchCondition['location.name']) {
      delete searchCondition['location.name'];
    }
    if (searchCondition.$and) {
      searchCondition.$and = searchCondition.$and.filter(
        (c: any) => !c['location.name']
      );
      if (searchCondition.$and.length === 0) {
        delete searchCondition.$and;
      }
    }

    const cityCondition = { 'location.name': this.cityDisplay };

    if (searchCondition.$and) {
      searchCondition.$and.push(cityCondition);
      this.searchCondition = searchCondition;
    } else if (Object.keys(searchCondition).length > 0) {
      this.searchCondition = { $and: [cityCondition, searchCondition] };
    } else {
      this.searchCondition = cityCondition;
    }

    console.log(
      'Final Search Condition:',
      JSON.stringify(this.searchCondition, null, 2)
    );
  }

  clearCity(event: MouseEvent) {
    event.stopPropagation();
    this.cityDisplay = '';
    this.citySearchText = '';
    this.searchCity = '';
    this.cityResults = [];
    this.cityActiveIndex = -1;
    this.showCityDropdown = false;

    let searchCondition: any = { ...this.searchCondition };

    if (searchCondition['location.name']) {
      delete searchCondition['location.name'];
    }
    if (searchCondition.$and) {
      searchCondition.$and = searchCondition.$and.filter(
        (c: any) => !c['location.name']
      );

      if (searchCondition.$and.length === 0) {
        delete searchCondition.$and;
      } else if (searchCondition.$and.length === 1) {
        searchCondition = searchCondition.$and[0];
      }
    }

    this.searchCondition = searchCondition;

    console.log(
      'Final Search Condition after clear:',
      JSON.stringify(this.searchCondition, null, 2)
    );
  }

  onCityKeydown(e: KeyboardEvent) {
    if (!this.showCityDropdown || !this.cityResults.length) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      this.cityActiveIndex =
        (this.cityActiveIndex + 1) % this.cityResults.length;
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      this.cityActiveIndex =
        (this.cityActiveIndex - 1 + this.cityResults.length) %
        this.cityResults.length;
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (
        this.cityActiveIndex >= 0 &&
        this.cityActiveIndex < this.cityResults.length
      ) {
        this.selectCity(this.cityResults[this.cityActiveIndex]);
      }
    } else if (e.key === 'Escape') {
      this.showCityDropdown = false;
    }
  }

  fetchSuggestions(e: any) {
    const query = (e?.query ?? '').trim();
    if (!query) {
      this.suggestions = [];
      return;
    }
    const payload = { query };

    this.apiservice
      .getHttpDataPost('astro-ai/fetch_capital_latLon', payload)
      .subscribe({
        next: (resp: any) => {
          this.suggestions = Array.isArray(resp?.res)
            ? (resp.res as SearchItem[])
            : [];
        },
        error: () => (this.suggestions = []),
      });
  }

  handleSelect(item: SearchItem) {
    this.search_id = item?.key ?? null;
    this.selectedOption = item;
  }

  handleClear() {
    this.selectedOption = null;
    this.search_id = null;
    this.suggestions = [];
  }

  public applyFilters(): void {
    let searchCondition: any = { ...this.searchCondition };

    if (searchCondition.eventTimestamp) {
      delete searchCondition.eventTimestamp;
    }
    if (searchCondition.$and) {
      searchCondition.$and = searchCondition.$and.filter(
        (c: any) => !c.eventTimestamp
      );
      if (searchCondition.$and.length === 0) {
        delete searchCondition.$and;
      }
    }

    const formatDate = (date: Date): string => date.toISOString().split('T')[0];

    let eventTimestampCondition: any = null;
    if (this.filters.startDate || this.filters.endDate) {
      const eventTimestamp: any = {};
      if (this.filters.startDate) {
        eventTimestamp['$gte'] = formatDate(new Date(this.filters.startDate));
      }
      if (this.filters.endDate) {
        eventTimestamp['$lte'] = formatDate(new Date(this.filters.endDate));
      }
      eventTimestampCondition = { eventTimestamp };
    }

    const andConditions: any[] = [];

    if (eventTimestampCondition) {
      andConditions.push(eventTimestampCondition);
    }

    const keys = Object.keys(searchCondition);
    if (keys.length > 0) {
      andConditions.push(searchCondition);
    }

    this.searchCondition = { $and: andConditions };

    console.log(
      'Final Search Condition:',
      JSON.stringify(this.searchCondition, null, 2)
    );
  }

  trackByLoc(index: number, loc: string) {
    return loc;
  }

  toggleCharts() {
    this.showPast = !this.showPast;
    this.limit = 9;
    this.skip = 0;
    this.cityDisplay = '';
    this.filters.startDate = '';
    this.filters.endDate = '';
    this.search_id = '';
    this.searchTitleDisplay = '';
    this.searchCondition = {};
    this.searchError = false;
    this.onsearch = false;
    this.allIngressData = [];
    if (this.showPast) {
      this.finalsearchCondition = { viewPast: true };
    } else {
      this.finalsearchCondition = {};
    }
    this.fetchChartData(this.limit, this.skip, this.finalsearchCondition);
    this.fetchChartDataCount(this.limit, this.skip, this.finalsearchCondition);
  }

  onSearch(): void {
    console.log('searchCondition---------->>', this.searchCondition);

    const extractKeys = (condition: any): string[] => {
      let keys: string[] = [];

      if (condition.$and && Array.isArray(condition.$and)) {
        condition.$and.forEach((c: any) => {
          keys = [...keys, ...extractKeys(c)];
        });
      } else {
        keys = keys.concat(Object.keys(condition));
      }

      return keys;
    };

    const keys = extractKeys(this.searchCondition);

    const allowedFilters = ['location.name', 'eventTimestamp', '_id'];
    const activeFilters = keys.filter((k) => allowedFilters.includes(k));

    if (activeFilters.includes('_id') && activeFilters.length > 1) {
      console.error('❌ Invalid filter: Title (_id) must be used alone.');
      this.searchError = true;
      return;
    }

    if (activeFilters.length === 2) {
      const validCombo =
        activeFilters.includes('location.name') &&
        activeFilters.includes('eventTimestamp');
      if (!validCombo) {
        console.error('❌ Invalid filter combination.');
        this.searchError = true;
        return;
      }
    }

    this.onsearch = true;
    this.limit = 9;
    this.skip = 0;

    let finalCondition = { ...this.searchCondition };

    if (Object.keys(finalCondition).length === 0) {
      if (this.showPast) {
        finalCondition = { viewPast: true };
      }
    }

    this.finalsearchCondition = finalCondition;

    this.allIngressData = [];
    this.fetchChartData(this.limit, this.skip, this.finalsearchCondition);
    this.fetchChartDataCount(this.limit, this.skip, this.finalsearchCondition);

    console.log('✅ Search is valid, fetching data...');
  }

  onReset() {
    this.cityDisplay = '';
    this.filters.startDate = '';
    this.filters.endDate = '';
    this.search_id = '';
    this.searchTitleDisplay = '';
    this.searchCondition = {};
    this.searchError = false;
    this.onsearch = false;
    this.authorDisplay = '';
    this.authorSearchText = '';
    this.searchUserId = '';
    this.authorResults = [];
    this.selectedSearchSectors = [];
    this.authorActiveIndex = -1;
    this.showauthorDropdown = false;
    this.limit = 9;
    this.skip = 0;
    this.allIngressData = [];
    if (this.showPast) {
      this.finalsearchCondition = {
        viewPast: true,
      };
    } else {
      this.finalsearchCondition = {};
    }

    this.fetchChartData(this.limit, this.skip, this.finalsearchCondition);
    this.fetchChartDataCount(this.limit, this.skip, this.finalsearchCondition);
  }
  onSectorChange(event: any) {
    console.log('Selected Sectors:', this.selectedSearchSectors);

    let searchCondition: any = { ...this.searchCondition };

    if (searchCondition.$and) {
      searchCondition.$and = searchCondition.$and.filter(
        (c: any) => !c['sector_focus']
      );
      if (searchCondition.$and.length === 0) {
        delete searchCondition.$and;
      }
    } else if (searchCondition['sector_focus']) {
      delete searchCondition['sector_focus'];
    }

    if (this.selectedSearchSectors.length === 0) {
      this.searchCondition = searchCondition;
      console.log(
        'Final Search Condition (no sectors):',
        JSON.stringify(this.searchCondition, null, 2)
      );
      return;
    }

    const sectorCondition = {
      sector_focus: { $in: this.selectedSearchSectors },
    };

    // Insert condition
    if (searchCondition.$and) {
      searchCondition.$and.push(sectorCondition);
      this.searchCondition = searchCondition;
    } else if (Object.keys(searchCondition).length > 0) {
      this.searchCondition = { $and: [sectorCondition, searchCondition] };
    } else {
      this.searchCondition = sectorCondition;
    }

    console.log(
      'Final Search Condition:',
      JSON.stringify(this.searchCondition, null, 2)
    );
  }

  public formatDate(timestamp: string): string {
    return new Date(timestamp).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }

  public getImportanceStyles(importance: string): string {
    switch (importance) {
      case 'High Impact':
        return 'importance-high';
      case 'Moderate Influence':
        return 'importance-moderate';
      case 'Subtle Shift':
        return 'importance-subtle';
      default:
        return 'importance-default';
    }
  }
}
